import { type UseQueryOptions, useQuery } from "@tanstack/react-query";

import {
	getContractsIdRequiredDocuments,
	type RequiredDocumentResponse,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import keys from "../keys";

export const useRequiredDocumentsQuery = (
	contractId: string | null | undefined,
	options?: Omit<
		UseQueryOptions<RequiredDocumentResponse[]>,
		"queryKey" | "queryFn"
	>,
) => {
	return useQuery({
		queryKey: keys.requiredDocuments(contractId),
		queryFn: processResponse(() =>
			getContractsIdRequiredDocuments(contractId as string),
		),
		enabled: !!contractId,
		...options,
	});
};
